// Resolves app-absolute asset paths (e.g. "/assets/cards/look.png") against the
// build's public path. On the normal build PUBLIC_URL is "" so the path is
// returned unchanged (absolute, domain-root). On the itch build PUBLIC_URL is "."
// so it becomes relative ("./assets/...") and resolves under the nested iframe path.
// Backend-provided image URLs use the same "/assets/..." convention, so they pass
// through here too. Full URLs (http/https) are returned untouched.
const PUBLIC_URL = process.env.PUBLIC_URL || '';

export function assetUrl(path: string): string {
  if (!path || /^(https?:)?\/\//.test(path)) return path;
  return PUBLIC_URL + (path.startsWith('/') ? path : `/${path}`);
}
